import classNames from 'classnames';
import { CustomPicker, /*ColorResult, Color, RGBColor, HSLColor, Color, ColorResult */} from 'react-color';
import { Saturation, Hue } from 'react-color/lib/components/common';

// const hexToHsl = require('hex-to-hsl');

interface ColorPickerProps {
	value: string;
	label: string;
	open: boolean;
	close: () => void;
}

function Pointer(props: any) {
	return (
		<div className="color-pointer" style={{ backgroundColor: props.value }}>
		</div>
	);
}

function PointerHue(props: any) {
	return (
		<div className="color-pointer hue-pointer" style={{ backgroundColor: props.value }}>
		</div>
	);
}

// function hexToRgb(value: string) {
// 	const val = !value.startsWith('#') ? "#" + value : value;
// 	const r = parseInt("0x" + val[1] + val[2], 16);
// 	const g = parseInt("0x" + val[3] + val[4], 16);
// 	const b = parseInt("0x" + val[5] + val[6], 16);

// 	return { r, g, b };
// }
//https://brandlive-upload.s3-us-west-2.amazonaws.com/uploads/17/documents/3a4yy8v10w/Screen_Shot_2020-11-02_at_9.05.59_AM.png
function ColorPicker(props: ColorPickerProps | any) {
	const {
		open,
	} = props;

	return (
		<div className={classNames("color-picker-wrapper", { open: open })}>
			{/* {open && <div className="color-picker-background" onClick={close}></div>} */}
			<div className={classNames("color-picker-container", { open: open })}>
				<div className="saturation" style={{ position: 'relative' }}>
					<Saturation
						{...props}
						pointer={Pointer}
						onChange={props.onChange}

					/>
				</div>
				<div className="hue" style={{ position: 'relative' }}>
					<Hue
						{...props}
						pointer={PointerHue}
						onChange={props.onChange}
						radius={7}
					/>
				</div>
			</div>
		</div>
	);
}

export default CustomPicker(ColorPicker);